interface RecaptchaVerificationResponse {
  success: boolean;
  score?: number;
  action?: string;
  challenge_ts?: string;
  hostname?: string;
  message: string;
  'error-codes'?: string[];
}

class RecaptchaService {
  private baseUrl: string;

  constructor() {
    // Use environment variable or default to local Firebase Functions
    // Remove /verifyRecaptcha from the URL since we append it in the request
    let baseUrl = process.env.REACT_APP_FIREBASE_FUNCTIONS_URL || 
                   'http://localhost:5001/your-project-id/us-central1';
    
    // Remove /verifyRecaptcha if it's already in the URL
    if (baseUrl.endsWith('/verifyRecaptcha')) {
      baseUrl = baseUrl.replace('/verifyRecaptcha', '');
    }
    
    this.baseUrl = baseUrl;
  }

  async verifyToken(token: string, action?: string): Promise<RecaptchaVerificationResponse> {
    try {
      const url = `${this.baseUrl}/verifyRecaptcha`;
      const requestBody = {
        token,
        action: action || 'default',
      };
      
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data: RecaptchaVerificationResponse = await response.json();
      return data;
    } catch (error) {
            throw new Error('Failed to verify reCAPTCHA token');
    }
  }

  async verifyWithScore(token: string, action?: string, minScore: number = 0.5): Promise<boolean> {
    try {
      const result = await this.verifyToken(token, action);
      
      if (!result.success) {
        return false;
      }

      // For reCAPTCHA v3, check score if available
      if (result.score !== undefined && result.score < minScore) {
                return false;
      }

      return true;
    } catch (error) {
            return false;
    }
  }
}

export const recaptchaService = new RecaptchaService();
export default RecaptchaService;
